module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_aplusplus-e85601651cef2904de316b06bfdd8eb9.png";